import PrivateRoutes from 'routes/PrivateRoutes';

import Documentation from 'components/Documentation/Documentation';
import Mobile from 'components/Kiosk/Mobile';
import KioskActivate from 'components/Kiosk/views/Activate';
import KioskIdle from 'components/Kiosk/views/Idle';
import KioskPhone from 'components/Kiosk/views/Phone';
import RegisterPatient from 'components/Kiosk/views/RegisterPatient';
import Login from 'components/Login/Login';
import MFADescription from 'components/MFADescription';
import NotFound from 'components/NotFound';
import ScheduleAppointment from 'components/Patient/self_scheduling';
import Terms from 'components/Terms';
import IconsPage from 'components/admin/pages/IconsPage/IconsPage';
import PreferredLocation from 'components/admin/pages/Practices/forms/PreferredLocation';
import RWTPlan from 'components/public/RWTPlan/RWTPlan';
import NewContactContainer from 'components/shared/contact/contact_container';

import CHECK_IN from './checkin';

const PUBLIC = [
  {
    path: '',
    element: <PrivateRoutes type="empty" />,
    children: [
      {
        path: '/',
        element: <Login loginType="user" />
      }
    ]
  },
  {
    path: 'rwt-plan',
    element: <RWTPlan />
  },
  {
    path: 'mfa-description',
    element: <MFADescription />
  },
  {
    path: 'documentation', // TODO: @rasim this is not public, check it.
    element: <Documentation />
  },
  {
    path: 'icons',
    element: <IconsPage />
  },
  {
    path: 'contact',
    element: <NewContactContainer />
  },
  {
    path: 'privacy',
    element: <Terms />
  },
  {
    path: 'mobile',
    element: <Mobile />,
    children: [
      { path: 'idle', element: <KioskIdle /> },
      { path: 'phone', element: <KioskPhone /> },
      { path: 'activate', element: <KioskActivate /> },
      { path: 'register', element: <RegisterPatient /> },
      { path: 'schedule-appointment', element: <ScheduleAppointment /> },
      ...CHECK_IN,
      {
        path: '*',
        element: <NotFound portal="kiosk" />
      }
    ]
  },

  {
    path: 'select-practice',
    element: <PreferredLocation />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default PUBLIC;
